<form [formGroup]="dobForm" class="row">

    <label class="input-lbl col-sm-12" tabindex="-1"> <span aria-hidden="true"
            class="mat-placeholder-required mat-form-field-required-marker">*
        </span>{{'FORMS.DOB_LABEL' | translate}}</label>

    <div class="col-sm-2">
        <label class="input-lbl" tabindex="-1"> <span aria-hidden="true"
                class="mat-placeholder-required mat-form-field-required-marker">
                *</span>
            {{'COMMON.DAY' | translate}}</label>

        <!-- day -->
        <mat-form-field appearance="outline" class="custom-dob-mat-form">
            <input matInput formControlName="day" autocomplete="off" maxlength="2" type="numeric"
                (keydown)="keyPressDobField($event)" (change)="keyPressDobField($event)"
                (keyup)="keyPressDobField($event)">
        </mat-form-field>
    </div>

    <div class="col-sm-3">
        <label class="input-lbl" tabindex="-1"> <span aria-hidden="true"
                class="mat-placeholder-required mat-form-field-required-marker">
                *</span>
            {{'COMMON.MONTH' | translate}}</label>

        <!-- month-->
        <mat-form-field appearance="outline" class="custom-dob-mat-form">
            <select matNativeControl formControlName="month" (change)="onQuestionChange($event)" [value]='-1'>
                <option></option>
                <option *ngFor="let month of months" [value]="month.id">
                    {{month.name | translateSplit }}
                </option>
            </select>
        </mat-form-field>
    </div>

    <div class="col-sm-2">
        <label class="input-lbl" tabindex="-1"> <span aria-hidden="true"
                class="mat-placeholder-required mat-form-field-required-marker">
                *</span>
            {{'COMMON.YEAR' | translate}}</label>

        <!-- year -->
        <mat-form-field appearance="outline" class="custom-dob-mat-form">
            <input matInput formControlName="year" type="numeric" maxlength="4" (keydown)="keyPressDobField($event)"
                (change)="keyPressDobField($event)" autocomplete="off" (keyup)="keyPressDobField($event)">
        </mat-form-field>
    </div>

    <div *ngIf="form?.dob?.errors && submitted" class="col-sm-5">
        <mat-error *ngIf='form?.dob.errors.required' class="dob-mat-error" tabindex="0">
            {{'FORMS.DOB_IS_REQUIRED' | translate}}
        </mat-error>

        <mat-error *ngIf="form?.dob.errors.incorrect" class="dob-mat-error" tabindex="0">
            {{'FORMS.DOB_INVALID' | translate}}
        </mat-error>
    </div>
</form>